import styled from '@emotion/styled';

const StyledBottomDiv = styled.div(
  {
    color: 'rgba(255,255,255,0.83)',
    display: 'inline-block',
    height: '100%',
    lineHeight: '18px',
    marginBottom: '103px',
    paddingTop: '32px'
  },
  ({ theme }) => ({
    fontSize: theme.typography.fontSize.medium
  })
);

export default StyledBottomDiv;
